import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../ui/base-components/pai-button';

interface Props {
  text: string;

  action?(): void;
  actionText?: string;
}

const PlaceholderElement: React.FC<Props> = ({ text, action, actionText }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.placeholder}>
      <Stack gap={4}>
        <Typography className={classes.placeholderText}>{text}</Typography>
        {!_.isNil(action) && !_.isNil(actionText) ? (
          <Stack direction={'row'} justifyContent={'center'}>
            <PaiButton action={action} text={actionText} />
          </Stack>
        ) : null}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  placeholder: {
    width: '100%',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '20px 48px',
    height: 'calc(100% - 39px - 16px - 20px)',
  },
  placeholderText: {
    fontSize: theme.typography.pxToRem(18),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
}));

export default PlaceholderElement;
